import LocalFireDepartmentOutlined from "@mui/icons-material/LocalFireDepartmentOutlined";

import { makeSvgIcon } from "./svg-icon";

export const CatalystIcon = makeSvgIcon(LocalFireDepartmentOutlined);

export default CatalystIcon;
